import { useTranslation } from "react-i18next";

import {
  SurveyQuestionType,
  type SurveyQuestion,
  type SurveyQuestionAutomation,
  type SurveyTemplate,
} from "@fitness-app/data-models/entities/SurveyTemplate";

import { PermissionKey, PermissionScope } from "@fitness-app/data-models";

import ABAnswer from "~/components/SurveyDetails/SurveyAnswers/ABAnswer";
import ScaleAnswer from "~/components/SurveyDetails/SurveyAnswers/ScaleAnswer";
import SelectAnswer from "~/components/SurveyDetails/SurveyAnswers/SelectAnswer";
import TextAnswer from "~/components/SurveyDetails/SurveyAnswers/TextAnswer";
import { usePermission } from "~/hooks/usePermission";
import SurveyQuestionAutomationForm from "~/modules/SurveysTemplates/SurveyDetails/SurveyQuestionAutomationForm";

interface SurveyExampleAnswerProps {
  question: SurveyQuestion;
  surveyId: string;
  model?: SurveyQuestionAutomation[];
  survey?: SurveyTemplate;
}

const SurveyExampleAnswer = ({ question, surveyId, model, survey }: SurveyExampleAnswerProps) => {
  const { t } = useTranslation("surveys");
  // Automatyzacja odpowiedzi to konfiguracja tenantowa, nie edycja ankiety.
  const canConfigureAutomation = usePermission(PermissionKey.AUTOMATION_MANAGE, PermissionScope.ALL);
  let Component = null;
  if (question.type === SurveyQuestionType.Text) {
    Component = <TextAnswer />;
  }
  if (question.type === SurveyQuestionType.AB) {
    Component = <ABAnswer extendedAnswerA={question.extendedAnswerA} extendedAnswerB={question.extendedAnswerB} />;
  }
  if (question.type === SurveyQuestionType.Select) {
    Component = <SelectAnswer options={question.answers} multiSelect={question.multiSelect} />;
  }
  if (question.type === SurveyQuestionType.Scale) {
    Component = (
      <ScaleAnswer
        min={question.min}
        max={question.max}
        step={question.step}
        variant={question.variant}
        minLabel={question.minLabel}
        maxLabel={question.maxLabel}
      />
    );
  }

  if (Component) {
    return (
      <div>
        <p>{t("exampleAnswers")}</p>
        {Component}
        {canConfigureAutomation && "id" in question && survey && (
          <SurveyQuestionAutomationForm question={question} surveyId={surveyId} model={model} survey={survey} />
        )}
      </div>
    );
  }
  return null;
};

export default SurveyExampleAnswer;
